import MarkdownRenderer from "@/components/UI/MarkdownRenderer";

export default function InsightAnswer({
  answer,
}: {
  answer: string | null | undefined;
}) {
  return (
    <div className="markdown max-h-[480px] overflow-y-auto text-sm text-[#2B4752] font-medium [&>*:last-child]:mb-0!">
      <MarkdownRenderer content={answer || "No answer yet."} />
    </div>
  );
}
